import { Stack } from '@mui/material';
import get from 'lodash-es/get';
import React from 'react';

import { useConstants } from '../../../hooks/useConstants';
import AccordionSection from '../../forms/AccordionSection';
import AdChoices from './fields/AdChoices';
import AdType from './fields/AdType';
import Api from './fields/Api';
import Associated from './fields/Associated';
import AutoTag from './fields/AutoTag';
import GenerateMacros from './fields/AutoTag/MacroHandler/GenerateMacros';
import Category from './fields/Category';
import CtrTierInput from './fields/CtrTierInput';
import CustomSchedule from './fields/CustomSchedule';
import GenerateATag from './fields/GenerateATag';
import IasInternalPixel from './fields/IasInternalPixel';
import Lpu from './fields/Lpu';
import Name from './fields/Name';
import Properties from './fields/Properties';
import Size from './fields/Size';
import Tag from './fields/Tag';
import ThirdPartyTagIds from './fields/ThirdPartyTagIds';
import Variables from './fields/Variables';

interface BannerProps {
  adGroupId?: number;
  onImageUpdate?: (newImageUrl: string) => void; // Make onImageUpdate optional to match defaultProps
}

function Banner({ adGroupId, onImageUpdate = () => {} }: BannerProps) {
  const { constants } = useConstants();
  const AUTODETECT_SIZE = get(constants, 'CREATIVE.AUTODETECT_SIZE');

  return (
    <Stack spacing={2}>
      <Name />
      {Boolean(adGroupId) && <Associated />}
      <Category />
      <Properties />
      <Stack direction="row" spacing={2}>
        <Size defaultValue={AUTODETECT_SIZE} />
        <AdType />
        <Api />
      </Stack>
      <Stack direction="row" spacing={2}>
        <GenerateATag />
        <GenerateMacros />
        <CtrTierInput />
        <AdChoices />
        <IasInternalPixel />
      </Stack>
      <AutoTag onImageUpdate={onImageUpdate} />
      <Variables />
      <AccordionSection>
        <Stack spacing={2}>
          <Tag />
          <Lpu />
          <ThirdPartyTagIds />
          <CustomSchedule />
        </Stack>
      </AccordionSection>
    </Stack>
  );
}

export default Banner;
